import { compose, prop, propOr, values } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';
import user from 'features/views/user';

import { restrictBy } from '../utils';
import { NAME } from './constants';

const getRoot = prop(NAME);

export const getIdkChannels = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'idk'));
export const getEdkChannels = compose(getRoot, propOr(EMPTY_VALUES.ARRAY, 'edk'));
export const getAllChannels = createSelector(getIdkChannels, getEdkChannels, (idk, edk) => idk.concat(edk));

export const getAllowedChannelsByCampaignId = createSelector(
	getIdkChannels,
	(state, campaignId) => user.selectors.getAllowedChannelsWithCampaign(state, campaignId),
	(_, campaignId, allowedChannels) => allowedChannels,
	(channels, userAllowedChannels, allowedChannels) => {
		return compose(restrictBy(allowedChannels), restrictBy(userAllowedChannels), values)(channels);
	},
);

export const getOrganizationStructureChannels = createSelector(
	getIdkChannels,
	(state, isGuarantor) => isGuarantor,
	user.selectors.getAllowedChannels,
	(channels, isGuarantor, allowedChannels) => {
		const finalAllowedChannels = isGuarantor ? EMPTY_VALUES.ARRAY : allowedChannels;
		return compose(restrictBy(finalAllowedChannels), values)(channels);
	},
);

// special logic for sidebar orgStructure element
export const getOrganizationStructureChannelsForSidebar = createSelector(
	getIdkChannels,
	user.selectors.getAllowedChannels,
	(state, isGuarantor) => isGuarantor,
	(state, isGuarantor, customAllowedChannels) => customAllowedChannels,
	(channels, baseAllowedChannels, isGuarantor, customAllowedChannels) => {
		if (isGuarantor) {
			return compose(restrictBy([]), values)(channels);
		} else {
			return compose(restrictBy(customAllowedChannels), restrictBy(baseAllowedChannels), values)(channels);
		}
	},
);
